module.exports = __webpack_public_path__ + "assets/ziyuan_11.a1c6fa5d.svg";